import { useState } from 'react';
import { useStudioPeriodVisibility } from 'src/components/star-grid/hooks/useStudioPeriodVisibility';
import type { StudioColumn, StudioScenarioBlock } from 'src/components/star-grid/reportStudio.types';
import type { ReportStudioState } from 'src/components/star-grid/hooks/useReportStudio';
import { pairStudioPeriods } from 'src/components/star-grid/utils/studioPeriods';
export const useStudioColumn = (column: StudioColumn, state: ReportStudioState) => {
  const [open, setOpen] = useState(false);
  const periodsRef = useStudioPeriodVisibility(column, state.template.catalog.periods);
  const scenarios = state.deck.columns.filter((item): item is StudioScenarioBlock => item.kind === 'scenario');
  const options = scenarios.map((item, index) => ({
    id: item.id,
    label: `${index + 1}. ${item.label || item.scenario_id} · ${
      state.template.catalog.versions.find((version) => version.id === (item.version_id ?? state.draft.definition.default_version_id))?.label ?? ''
    }`
  }));
  const base = column.kind === 'variance' ? scenarios.find((item) => item.id === column.base_block_id) : undefined;
  const compare = column.kind === 'variance' ? scenarios.find((item) => item.id === column.compare_block_id) : undefined;
  const togglePeriod = (id: string) => {
    if (column.kind === 'scenario')
      state.updateColumn({
        ...column,
        period_ids: column.period_ids.includes(id) ? column.period_ids.filter((item) => item !== id) : [...column.period_ids, id]
      });
  };
  const mapPeriods = (mode: 'same' | 'prior_year' | 'prior_period') => {
    if (column.kind === 'variance' && base)
      state.updateColumn({ ...column, period_pairs: pairStudioPeriods(base.period_ids, state.template.catalog.periods, mode) });
  };
  return { open, setOpen, scenarios, options, base, compare, togglePeriod, mapPeriods, periodsRef };
};
